export default "__VITE_ASSET__mbIX7yU8__"